module.exports = __webpack_public_path__ + "static/openhealing_map_world-86042a7a05862f208ebc2a52339bd2f8.jpg";